import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  PAYMENT_SETUP_GET_LINK_FETCH_REQUEST,
  PAYMENT_SETUP_GET_LINK_FETCH,
} from 'store/constants/paymentSettingsTypes';

// helpers
import getResponsePayload from 'helpers/getResponsePayload';
import Immutable from 'immutable';
import httpSaga from 'store/sagas/httpSaga';

// schema
import { paymentSetupSchema } from 'store/schemas/paymentSetupSchema';

const WATCH_TYPE = PAYMENT_SETUP_GET_LINK_FETCH_REQUEST;
const TYPE = PAYMENT_SETUP_GET_LINK_FETCH;

export function* fetchPaymentStripeLinkSaga(action: any) {
  const {
    payload: { groupId, returnUrl, refreshUrl },
  } = action || {};

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  const response = yield* httpSaga(
    TYPE,
    call(client.post, `/payment_setup/get_link?group_id=${groupId}`, {
      return_url: returnUrl,
      refresh_url: refreshUrl,
    })
  );

  const payload = getResponsePayload(response, [paymentSetupSchema]);

  yield put(success(TYPE, Immutable.fromJS(payload)));

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, fetchPaymentStripeLinkSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
